<ion-content>
  <div>
    <div class="profile ion-padding">
      <div class="ion-text-center">
        <img class="logo" src="assets/pe-pro-logo.png" alt="PE Pro Logo" />
      </div>
      <h2 class="ion-text-center">{{ credentialsService.userData?.name }}</h2>
    </div>
  </div>

  <ion-card>
    <ion-card-content>
      <p><strong>Name:</strong> {{ credentialsService.userData?.name }}</p>
      <p><strong>Email/Username:</strong> {{ credentialsService.userData?.email }}</p>
      @if (credentialsService?.userLicence && credentialsService?.userLicence?.expiresAt) {
        <p>
          <strong>License Expires:</strong>
          {{ credentialsService.userLicence.expiresAt?.toDate() | date: 'dd/MM/yyyy' }}
        </p>
      }
      @if (credentialsService.userLicence?.trial) {
        <p>
          <strong>You are a trial user</strong>
        </p>
      }
    </ion-card-content>
  </ion-card>

  @if (credentialsService.userRole?.isAdmin) {
    <ion-item routerLink="admin">
      <ion-icon name="key" slot="start"></ion-icon>
      <ion-label>Admin</ion-label>
    </ion-item>
  }

  @if (credentialsService.userRole?.permissions.editLicenceSettings) {
    <ion-item
      [routerLink]="['licence', credentialsService.userLicence?.id]"
      >
      <ion-icon name="settings-outline" slot="start"></ion-icon>
      <ion-label>Licence Settings</ion-label>
    </ion-item>
  }

  <ion-item [routerLink]="['c/support']">
    <ion-icon name="help-outline" slot="start"></ion-icon>
    <ion-label>Support</ion-label>
  </ion-item>

  <ion-item (click)="deleteUser()">
    <ion-icon color="danger" name="trash-outline" slot="start"></ion-icon>
    <ion-label color="danger">Delete my account</ion-label>
  </ion-item>

  <ion-item button (click)="logout()">
    <ion-icon name="exit-outline" slot="start"></ion-icon>
    <ion-label>Logout</ion-label>
  </ion-item>
</ion-content>

<ion-footer class="ion-padding-start ion-padding-end ion-padding-bottom ion-padding-top ion-text-center">
  Got a problem? Email us at
  <a href="mailto:enquiries@peproapp.com">enquiries&#64;peproapp.com</a> <br />Current version:
  {{ version }}
</ion-footer>
